import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { EMPTY, Observable, catchError, throwError } from 'rxjs';
import { AppUpdateService } from '../services/app-update.service';

// The backend answers 426 Upgrade Required when the version reported in the x-platform
// header is below the minimum it supports for that platform. It is checked before
// authentication, so this can fire on the login request too.
const UPGRADE_REQUIRED = 426;

@Injectable()
export class VersionInterceptor implements HttpInterceptor {

  constructor(private appUpdate: AppUpdateService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === UPGRADE_REQUIRED) {
          this.appUpdate.forceUpgrade(error);
          // Swallow it. The blocking dialog is the only thing the user should see, not
          // whatever error message the calling component would otherwise put on screen.
          return EMPTY;
        }
        return throwError(() => error);
      })
    );
  }
}
